<template>
  <div class="container-fluid my-0 movin-obj">
    <div class="row">
      <div class="col-12">
        <div class="">
          <img src="../assets/photo/movin-obj.png" alt="" class="w-100 movin-obj-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
